import React, { useState, useEffect } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import CentrikaIcon from "../../assets/img/logo.png";
import SafariBusWhite from "../../assets/img/logo_white.svg";
import {
  Button,
  Drawer,
  ListItemText,
  IconButton,
  ListItemIcon,
  ListItem,
  Divider,
  List,
  Grid,
  Paper,
  Typography,
  Toolbar,
  AppBar,
  Container,
  Box,
  Hidden,
  Menu,
  MenuItem,
  Avatar,
  useMediaQuery,
  Badge,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";

import {
  Menu as MenuIcon,
  Home,
  AccountCircle,
  Equalizer,
  Business,
  VerifiedUser,
  Settings as SettingsIcon,
  ExitToApp,
  ArrowDropDown,
  QuestionAnswer,
  HelpRounded,
  BrightnessHigh,
  Brightness4,
  Notifications,
  Email,
  Group,
  SupervisedUserCircle,
  BusinessCenter,
  Store,
  Security,
  ExpandLess,
  ExpandMore,
  ArrowRight,
  Forum, House as InventoryIcon,
  CardGiftcard
} from "@material-ui/icons";

import { makeStyles, useTheme } from "@material-ui/styles";
import { Speed } from "@material-ui/icons";

import OperatorsList from "./pages/operators_list.jsx";
import Dashboard from "./pages/dashboard.jsx";
import Accounts from "./pages/submenus/accounts/accounts.jsx";
import SystemUsers from "./pages/users.jsx";
import AppUsers from "./pages/app_users.jsx";
import Organizations from "./pages/organizations.jsx";
import Inventory from "./pages/inventory.jsx";
import InventoryTwo from "./pages/invetory_v_2.jsx";
import InvetoryCustomers from "./pages/customers.jsx";

import RolesPrivileges from "./pages/roles_privileges.jsx";

import { AccountCommisions } from "./pages/submenus/accounts/commissions";
import { ServiceFeeConfiguration } from "./pages/submenus/accounts/service_fee";
import AccountDetails from "./pages/submenus/accounts/details/account_details";

import Settings from "./pages/settings.jsx";

import NotFound from "./pages/404.jsx";
import Welcome from "./pages/welcome"

import Individual from "./pages/submenus/agents/individual.jsx";
import Integration from "./pages/submenus/agents/integration.jsx";
import Private from "./pages/submenus/agents/private.jsx";
import Global from "./pages/submenus/agents/global.jsx";

import Transaction from "./pages/submenus/agents/transaction.jsx";
import PrivateAgentDetails from "./pages/submenus/agents/private_agent_details.jsx";
import IndividualAgentDetails from "./pages/submenus/agents/individual_agent_details.jsx";
import GlobalAgentDetails from "./pages/submenus/agents/global_agent_details.jsx";
import CorporateDetails from "./pages/corporate_details";

import Batches from "./pages/submenus/reports/finance/batches";

import OperatorsAccounts from "./pages/submenus/accounts/operators.jsx";
import AgentsAccounts from "./pages/submenus/accounts/agents.jsx";
import DevicesAccounts from "./pages/submenus/accounts/devices.jsx";
import CustomersAccounts from "./pages/submenus/accounts/customers.jsx";
import InternalAccounts from "./pages/submenus/accounts/internal_accounts";
import ServiceFeeAccounts from "./pages/submenus/accounts/service_fee_accounts"; 

import { FinanceReport } from "./pages/submenus/reports/finance.jsx";
import { FinTransactions } from "./pages/submenus/reports/finance/financial_transactions.jsx";
import { OperatorsReport } from "./pages/submenus/reports/operators.jsx";
import { SystemReport } from "./pages/submenus/reports/system.jsx";
import { InventoryReport } from "./pages/submenus/reports/inventory.jsx";

import { InventoryReportTwo } from "./pages/submenus/reports/inventory_two.jsx";

import CreateBusinessRules from "./pages/submenus/wizanalytics/create_business_rules.jsx";
import UserAward from "./pages/submenus/wizanalytics/user_awards.jsx";

import Messaging from "./pages/messaging.jsx";
import OperatorHome from "./pages/operator_home.jsx";
import CentrikaView from "./pages/centrika_view.jsx";

import PosAgents from "./pages/submenus/agents/pos_agents.jsx";

import ServiceRegistry from "./pages/settings/service_registry";

import { withLocalize } from "react-localize-redux";

import { Link, Switch, Route, useHistory } from "react-router-dom";

import { AdminService, Permissions ,hasPermission} from "../../utils/web_config";
import Cooperatives from "./pages/cooperatives";

import FraudulentCardTaps from "./../operator/other-reports/FraudulentCardTaps";
import Interoperability from "./../ac_group/dashboard"


import AgentTopUpRequest from "./pages/submenus/requests/agent_topup_requests"
import TransactionReversalRequest from "./pages/submenus/requests/transaction_reversal_request"
import RefundRequest from "./pages/submenus/requests/refund_request"

import BnrTrustAccReport from "./pages/submenus/reports/bnr/bnr_trust_acc_report.jsx"
import BnrChallengesWayforward from "./pages/submenus/reports/bnr/bnr_consumer_protection.jsx"
import BnrConsumerProtection from "./pages/submenus/reports/bnr/bnr_challenges_report.jsx"
import BnrNetworkPerformance from "./pages/submenus/reports/bnr/bnr_network_performance.jsx"
import BnrFraudManagement from "./pages/submenus/reports/bnr/bnr_fraud_management.jsx"
import AtmRefundRequest from "./pages/submenus/requests/atm_refund_request.jsx";

const routes = [
  {
    path: "/centrika",
    exact: true,
    permission: "CAN_VIEW_HOME",
    main: () => <Dashboard />,
  },
  // {
  //   path: "/centrika/ac_group/home",
  //   exact: true,
  //   permission: "CAN_VIEW_HOME",
  //   main: () => <Dashboard />,
  // }, 
    {
    path: "/centrika/home",
    exact: true,
    permission: "CAN_VIEW_HOME",
      main: () => <Dashboard />,
  }, 
  {
    path: "/centrika/agentTopupRequest",
    exact: true,
    permission: "CAN_VIEW_HOME",
    main: () => <AgentTopUpRequest />,
  }, 
  {
    path: "/centrika/refundRequest",
    exact: true,
    permission: "CAN_VIEW_HOME",
    main: () => <RefundRequest />,
  }, 
  {
    path: "/centrika/atmRefundRequest",
    exact: true,
    permission: "CAN_VIEW_HOME",
    main: () => <AtmRefundRequest />,
  },
  {
    path: "/centrika/transactionReversal",
    exact: true,
    permission: "CAN_VIEW_HOME",
    main: () => <TransactionReversalRequest />,
  },
  {
    path: "/centrika/welcome",
    exact: true,
    main: () => <Welcome />,
  },
  {
    path: "/centrika/operators/messaging",
    exact: true,
    permission:"CAN_VIEW_COMMUNICATION",
    main: () => <Messaging />,
  },
  {
    path: "/centrika/operators",
    exact: true,
    permission: "CAN_LIST_OPERATOR",
    main: () => <OperatorsList />,
  },
  {
    path: "/centrika/cooperatives",
    exact: true,
    //permission: "CAN_LIST_OPERATOR",
    main: () => <Cooperatives/>,
  },
  {
    path: "/centrika/op/view",
    exact: true,
    main: () => <OperatorHome />,
  },
  {
    path: "/centrika/org/view",
    exact: true,
    main: () => <CentrikaView/>,
  },
  {
    path: "/centrika/agents/private",
    exact: true,
    permission: "CAN_LIST_AGENTS",
    main: () => <Private />,
  },
  {
    path: "/centrika/agents/individual",
    exact: true,
    permission: "CAN_LIST_AGENTS",
    main: () => <Individual />,
  },
  {
    path: "/centrika/agents/global",
    exact: true,
    permission: "CAN_LIST_AGENTS",
    main: () => <Global />,
  },
  {
    path: "/centrika/agents/details/viewTransaction",
    exact: true,
    main: () => <Transaction />,
  },
  {
    path: "/centrika/agents/indiv",
    exact: true,
    main: () => <IndividualAgentDetails />,
  },
  {
    path: "/centrika/agents/integr",
    exact: true,
    main: () => <Integration />,
  },
  {
    path: "/centrika/bnr/trustAccReport",
    exact: true,
    main: () => <BnrTrustAccReport />,
  }, 
  {
    path: "/centrika/bnr/challengesWayforward",
    exact: true,
    main: () => <BnrChallengesWayforward />,
  }, 
  {
    path: "/centrika/bnr/consumerProtection",
    exact: true,
    main: () => <BnrConsumerProtection />,
  }, 
    {
    path: "/centrika/bnr/networkPerformance",
    exact: true,
      main: () => <BnrNetworkPerformance />,
  }, 
  {
    path: "/centrika/bnr/frauds",
    exact: true,
    main: () => <BnrFraudManagement />,
  }, 
  {
    path: "/centrika/agents/glob",
    exact: true,
    main: () => <GlobalAgentDetails />,
  },
  {
    path: "/centrika/agents/corp",
    exact: true,
    main: () => <PrivateAgentDetails />,
  },
  {
    path: "/centrika/agent/edit",
    exact: true,
    main: () => <CorporateDetails />,
  },
  {
    path: "/centrika/accounts/all",
    exact: true,
    permission:"CAN_LIST_ACCOUNTS",
    main: () => <Accounts />,
  },
  {
    path: "/centrika/accounts/details",
    exact: true,
    main: () => <AccountDetails />,
  },
  {
    path: "/centrika/posAgents",
    exact: true,
    main: () => <PosAgents />,
  },
  {
    path: "/centrika/accounts/operators",
    exact: true,
    permission:"CAN_LIST_ACCOUNTS",
    main: () => <OperatorsAccounts />,
  },
  {
    path: "/centrika/accounts/agents",
    exact: true,
    permission:"CAN_LIST_ACCOUNTS",
    main: () => <AgentsAccounts />,
  },
  {
    path: "/centrika/accounts/devices",
    exact: true,
    permission:"CAN_LIST_ACCOUNTS",
    main: () => <DevicesAccounts />,
  },
  {
    path: "/centrika/accounts/customers",
    exact: true,
    permission:"CAN_LIST_ACCOUNTS",
    main: () => <CustomersAccounts />,
  },
  {
    path: "/centrika/accounts/internal",
    exact: true,
    permission:"CAN_LIST_ACCOUNTS",
    main: () => <InternalAccounts />,
  },
  {
    path: "/centrika/accounts/serviceFeeAccounts",
    exact: true,
    permission:"CAN_LIST_ACCOUNTS",
    main: () => <ServiceFeeAccounts />,
  }, 
  {
    path: "/centrika/accounts/commissions",
    exact: true,
    permission:"CAN_VIEW_COMMISSIONS",
    main: () => <AccountCommisions />,
  }, 
  {
    path: "/centrika/accounts/serviceFeeConfiguration",
    exact: true,
    permission:"CAN_VIEW_COMMISSIONS",
    main: () => <ServiceFeeConfiguration />,
  }, 

  {
    path: "/centrika/accounts/settlements/batches",
    exact: true,
    main: () => <Batches />,
  },
  {
    path: "/centrika/users/system",
    exact: true,
    permission:"CAN_LIST_USERS",
    main: () => <SystemUsers />,
  },
  {
    path: "/centrika/users/wallet",
    exact: true,
    permission:'CAN_LIST_USERS',
    main: () => <AppUsers />,
  },
  {
    path: "/centrika/reports/finance",
    exact: true,
    permission:"CAN_VIEW_REPORTS",
    main: () => <FinanceReport />,
  },
  {
    path: "/centrika/reports/finance/financialTransaction",
    exact: true,
    permission:"CAN_VIEW_REPORTS",
    main: () => <FinTransactions />,
  },
  {
    path: "/centrika/reports/operators",
    exact: true,
    permission:"CAN_VIEW_REPORTS",
    main: () => <OperatorsReport />,
  },
  {
    path: "/centrika/reports/system",
    exact: true,
    permission:"CAN_VIEW_REPORTS",
    main: () => <SystemReport />,
  },
  {
    path: "/centrika/reports/inventory",
    exact: true,
    main: () => <InventoryReport />,
  },
  {
    path: "/centrika/reports/inventorytwo",
    exact: true,
    main: () => <InventoryReportTwo />,
  },
  {
    path: "/centrika/reports/fraudulent-card-taps",
    exact: true,
    main: () => <FraudulentCardTaps />,
  },
  {
    path: "/centrika/organizations",
    exact: true,
    permission:"CAN_LIST_ORGANIZATIONS",
    main: () => <Organizations />,
  },
  {
    path: "/centrika/inventory",
    exact: true,
    permission:"CAN_VIEW_INVENTORY",
    main: () => <Inventory />,
  },
  {
    path: "/centrika/inventory_two",
    exact: true,
    permission:"CAN_VIEW_INVENTORY",
    main: () => <InventoryTwo />,
  },   
  {
    path: "/centrika/customer",
    exact: true,
    permission:"CAN_VIEW_INVENTORY",
    main: () => <InvetoryCustomers />,
  },
  {
    path: "/centrika/inventory/stock",
    exact: true,
    main: () => <Inventory />,
  },
  {
    path: "/centrika/roles",
    exact: true,
    permission:"CAN_VIEW_ROLES_AND_PRIVILEGES",
    main: () => <RolesPrivileges />,
  },
  {
    path: "/centrika/settings",
    exact: true,
    permission:"CAN_VIEW_SETTINGS",
    main: () => <Settings />,
  },
  {
    path: "/centrika/settings/services",
    exact: true,
    main: () => <ServiceRegistry />,
  },
  {
    path: "/centrika/wizanalytics/businessrules",
    exact: true,
    main: () => <CreateBusinessRules/>,
  },

  {
    path: "/centrika/wizanalytics/userawards",
    exact: true,
    main: () => <UserAward/>,
  },
  {
    main: () => <NotFound />,
  },
];

const menus = [
  { name: "Home", icon: <Home />, path: "/centrika/home",permission: "CAN_VIEW_HOME", },
  {
    name: "Operators",
    icon: <BusinessCenter />,
    path: "/centrika/operators",
    permission: "CAN_LIST_OPERATOR",
  },
  {
    name: "Cooperatives",
    icon: <Store />,
    path: "/centrika/cooperatives",
    //permission: "CAN_LIST_OPERATOR",
  },
  {
    name: "Agents",
    icon: <SupervisedUserCircle />,
    path: "/centrika/agents/private",
    permission: "CAN_LIST_AGENTS",
    submenu: [
      { name: "Private agents", path: "/centrika/agents/private",permission: "CAN_LIST_CORPORATE_AGENT", },
      { name: "Individual agents", path: "/centrika/agents/individual", },
      { name: "Global", path: "/centrika/agents/global" },
      { name: "Integration agents", path: "/centrika/agents/integr", },
    ],
  },
  {
    name: "Accounts",
    icon: <Group />,
    path: "/centrika/accounts/all",
    permission:"CAN_LIST_ACCOUNTS",
    submenu: [
      { name: "Operators", path: "/centrika/accounts/operators",permission: "CAN_VIEW_LIST_OF_OPERATORS_ACCOUNTS", },
      { name: "Agents", path: "/centrika/accounts/agents",permission: "CAN_LIST_LIST_OF_AGENTS_ACCOUNTS",  },
      { name: "Customers", path: "/centrika/accounts/customers",permission: "CAN_LIST_CUSTOMERS_ACCOUNT",  },
      { name: "Devices", path: "/centrika/accounts/devices" ,permission: "CAN_LIST_DEVICES_ACCOUNT", },
      { name: "Internal", path: "/centrika/accounts/internal",permission: "CAN_LIST_INTERNAL_ACCOUNT", },
      { name: "Commissions", path: "/centrika/accounts/commissions",permission:"CAN_VIEW_COMMISSIONS", }, 
      { name: "Service Fee", path: "/centrika/accounts/serviceFeeConfiguration",permission:"CAN_VIEW_COMMISSIONS", },
      { name: "Service Fee Accounts", path: "/centrika/accounts/serviceFeeAccounts",permission:"CAN_LIST_ACCOUNTS", }
    ],
  },

  {
    name: "Requests",
    icon: <Security />,
    path: "/centrika/accounts/all",
    permission: "CAN_LIST_ACCOUNTS",
    submenu: [
      { name: "Topup Requests", path: "/centrika/agentTopupRequest", permission: "CAN_VIEW_HOME", },
      { name: "Reversal Requests", path: "/centrika/transactionReversal", permission: "CAN_VIEW_HOME", },
      { name: "Refund Requests", path: "/centrika/refundRequest", permission: "CAN_VIEW_HOME", },
      { name: "ATM Refund Requests", path: "/centrika/atmRefundRequest", permission: "CAN_VIEW_HOME", }
      ],
  },
  {
    name: "Reports",
    icon: <Equalizer />,
    path: "/centrika/reports/finance",
    permission:"CAN_VIEW_REPORTS",
    submenu: [
      { name: "Finance report", path: "/centrika/reports/finance" },
      // { name: "Operators report", path: "/centrika/reports/operators" },
      { name: "System report", path: "/centrika/reports/system" },
      { name: "Inventory report", path: "/centrika/reports/inventory" },
      // { name: "Inventory report two", path: "/centrika/reports/inventorytwo" }
      { name: "Fraudulent Card Taps", path: "/centrika/reports/fraudulent-card-taps" },
      { name: "Inter Operability", path: "/centrika/ac_group/home" },
      { name: "BNR Trust Acc Report", path: "/centrika/bnr/trustAccReport" },
      { name: "BNR Challenges Report", path: "/centrika/bnr/challengesWayforward" } ,
      { name: "BNR Consumer Protection", path: "/centrika/bnr/consumerProtection" },  
      { name: "BNR Network Performance", path: "/centrika/bnr/networkPerformance" }, 
      { name: "BNR Frauds Report", path: "/centrika/bnr/frauds" }
    ],
  },
  {
    name: "Wizanalytics",
    icon: <CardGiftcard />,
    path: "/centrika/wizanalytics/businessrules",
    permission: "damn",
    submenu: [
      { name: "Business Rules", path: "/centrika/wizanalytics/businessrules"},
      { name: "User Awards", path: "/centrika/wizanalytics/userawards" },
    ],
  },
  {
    name: "All organizations",
    icon: <Business />,
    path: "/centrika/organizations",
    permission:"CAN_LIST_ORGANIZATIONS",
  },
  {
    name: "Inventory ",
    icon: <InventoryIcon />,
    path: "/centrika/inventory",
    permission:"CAN_VIEW_INVENTORY",
  }, 
  // {
  //   name: "Inventory Two",
  //   icon: <Store />,
  //   path: "/centrika/inventory_two",
  //   permission:"CAN_VIEW_INVENTORY",
  // },   
  // {
  //   name: "Customers",
  //   icon: <Group />,
  //   path: "/centrika/customer",
  //   permission:"CAN_VIEW_INVENTORY",
  // },
  {
    name: "Roles & Privileges",
    icon: <Security />,
    path: "/centrika/roles",
    permission:"CAN_VIEW_ROLES_AND_PRIVILEGES",
  },
  {
    name: "Users",
    icon: <AccountCircle/>,
    path: "/centrika/users",
    permission:"CAN_LIST_USERS",
    submenu: [
      { name: "Organization users", path: "/centrika/users/system" },
      { name: "Wallet users", path: "/centrika/users/wallet" },
    ],
  },
];

const menus2 = [
  {
    name: "Communication",
    icon: <Forum/>,
    path: "/centrika/operators/messaging",
    permission:"CAN_VIEW_COMMUNICATION",
  },
  { name: "Settings", icon: <SettingsIcon />, path: "/centrika/settings" ,permission:"CAN_VIEW_SETTINGS",},
  { name: "Logout", icon: <ExitToApp />, path: "/centrika/logout" },
];

const drawerWidth = 250;

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
    border: 0,
  },
  btn: {
    textTransform: "capitalize",
  },
  paper: {
    padding: 15,
  },
  icon: {
    height: 45,
    marginRight: 10,
    display: "block",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  icon2: {
    height: 35,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));

function CentrikaHome(props) {
  const { window } = props;
  const classes = useStyles();
  const Theme = useTheme();
  const history = useHistory();
  const { themer } = props;

  const [accountData, setAccountData] = useState({});

  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);
  const [logoutOpen, setLogoutOpen] = useState(false);

  const [openMenu, setOpenMenu] = useState("none");

  useEffect(() => {
    var accountData = new AdminService().accountData;
    setAccountData(accountData);
    if(!hasPermission("CAN_VIEW_HOME")){
      history.push("/centrika/welcome")
    }

    if(accountData.user_must_change_password){
      history.push("/centrika/settings",{open:true})
    }
    var data = {};
    const data1 = localStorage.getItem("nx_cent");
    if (data1 != null) {
      data = JSON.parse(data1);

      if (data.token == null) {
        history.replace("/");
        return;
      }
    } else {
      history.replace("/", { expired: true });
    }
  }, []);
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <div>
      <div className={classes.toolbar} />
      <Divider />
      <List>
        {menus.map((menu, index) => (
          <>
            <Permissions
              permissions={menu.permission ? menu.permission : "GRANTED"}
            >
              <ListItem
                button
                key={menu.name}
                onClick={() => {
                  if (menu.submenu) {
                    if (openMenu == index) {
                      setOpenMenu("none");
                    } else {
                      setOpenMenu(index);
                    }
                  } else {
                    history.push(menu.path);
                    setMobileOpen(false);
                  }
                }}
                selected={
                  menu.path == history.location.pathname && !menu.submenu
                }
              >
                <ListItemIcon>{menu.icon}</ListItemIcon>
                <ListItemText primary={menu.name} />
                {menu.submenu ? (
                  openMenu == index ? (
                    <ExpandLess />
                  ) : (
                    <ExpandMore />
                  )
                ) : (
                  <div />
                )}
              </ListItem>
              {menu.submenu && (
                <Collapse in={openMenu == index} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {menu.submenu.map((sub, i) => (
                      <Permissions
                      permissions={sub.permission ? sub.permission : "GRANTED"}
                    >
                      <ListItem
                        button
                        className={classes.nested}
                        onClick={() => {

                          if (sub.path ==="/centrika/ac_group/home"){
                            history.push("/ac_group/home")
                            return
                          }
                          
                          history.push(sub.path);
                          setMobileOpen(false);
                        }}
                        selected={sub.path == history.location.pathname}
                      >
                        <ListItemIcon>
                          <ArrowRight />
                        </ListItemIcon>
                        <ListItemText primary={sub.name} />
                      </ListItem>
                      </Permissions>
                    ))}
                  </List>
                </Collapse>
              )}
            </Permissions>
          </>
        ))}
      </List>
      <Divider />
      <List>
        {menus2.map((menu, index) => (
          <Permissions
          permissions={menu.permission ? menu.permission : "GRANTED"}
        >
          <ListItem
            button
            key={menu.name}
            onClick={() => {
              if (menu.path === "/centrika/logout") {
                setLogoutOpen(true);
              } else {
                history.push(menu.path);
              }
              setMobileOpen(false);
            }}
          >
            <ListItemIcon>{menu.icon}</ListItemIcon>
            <ListItemText primary={menu.name} />
          </ListItem>
          </Permissions>
        ))}
      </List>
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;
  const matches = useMediaQuery(Theme.breakpoints.up("sm"));

  return (
    <div className={classes.root}>
      <CssBaseline />
      {/* Logout dialog hereeeeeeeeee */}
      <Dialog
        open={logoutOpen}
        onClose={() => setLogoutOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Logout"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to logout of your account?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setLogoutOpen(false)} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              localStorage.removeItem("nx_cent");
              history.replace("/");
            }}
            color="primary"
            autoFocus
          >
            Logout
          </Button>
        </DialogActions>
      </Dialog>

      {/* //////////////////////// */}

      {/* <Dialog
        open={history.location.pathname=='/centrika/logout'}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Session expired"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Your login session has expired, please login again to continue.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            localStorage.removeItem("nx_cent")
            history.replace("/")
          }} color="primary">
            Close
          </Button>
          <Button onClick={() => {
            localStorage.removeItem("nx_cent");
            history.replace("/");
          }} color="primary" autoFocus>
            Login again
          </Button>
        </DialogActions>
      </Dialog> */}

      {/* ////////////////////////// */}

      <AppBar
        position="fixed"
        color={themer == 0 ? "primary" : "default"}
        elevation={0}
        className={classes.appBar}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>
          <img src={CentrikaIcon} alt="icon" className={classes.icon} />
          <Box className={classes.title}>
            <Typography variant="h5" noWrap>
              SafariBus
            </Typography>
          </Box>

          <Permissions permissions="CAN_VIEW_COMMUNICATION"><Box mr={matches && 2}>
            <IconButton
              color="inherit"
              onClick={() => {
                history.push("/centrika/operators/messaging");
              }}
            >
              <Badge
                badgeContent={0}
                showZero={false}
                variant="standard"
                color="secondary"
              >
                <Email />
              </Badge>
            </IconButton>
          </Box>
          </Permissions>

          <div>
            <Button
              onClick={handleMenu}
              color="inherit"
              variant={matches && "outlined"}
              size="small"
              className={classes.btn}
              startIcon={
                matches && (
                  <img
                    src={SafariBusWhite}
                    className={classes.icon2}
                    alt="Safaribus"
                  />
                )
              }
            >
              {<Avatar>{accountData?.user_name?.substring(0, 1)}</Avatar>}
            </Button>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              open={menuOpen}
              onClose={handleClose}
            >
              <Permissions permissions="CAN_LIST_USERS">
              <MenuItem
                onClick={() => {
                  handleClose();
                  history.push("/centrika/users/system");
                }}
              >
                System users
              </MenuItem>
              </Permissions>
              <Permissions permissions="CAN_VIEW_SETTINGS">
              <MenuItem
                onClick={() => {
                  handleClose();
                  history.push("/centrika/settings");
                }}
              >
                Settings
              </MenuItem>
              </Permissions>
              <MenuItem
                onClick={() => {
                  handleClose();
                  setLogoutOpen(true);
                }}
              >
                Logout
              </MenuItem>
              
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
      <nav className={classes.drawer} aria-label="Agent menus">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={Theme.direction === "rtl" ? "right" : "left"}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            elevation={0}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <Switch>
          {routes.map((route, i) => (
             
            <Route
              key={i}
              exact={route.exact}
              path={hasPermission(route.permission)? route.path:route.permission==null?route.path:"/centrika/"}
              component={route.main}
            />
          
          ))}
        </Switch>
      </main>
    </div>
  );
}

export default withLocalize(CentrikaHome);
